
/** Design system packages **/  
import * as a0 from '../../../packages/a11y'
import * as a1 from '../../../packages/accordion'
import * as a2 from '../../../packages/app-layout'
import * as a3 from '../../../packages/array-field'
import * as a4 from '../../../packages/aspect-ratio'
import * as a5 from '../../../packages/autocomplete'
import * as a6 from '../../../packages/avatar'
import * as a7 from '../../../packages/badge'
import * as a8 from '../../../packages/banner'
import * as a9 from '../../../packages/blanket'
import * as a10 from '../../../packages/bottom-drawer'
import * as a11 from '../../../packages/box'
import * as a12 from '../../../packages/breadcrumbs'
import * as a13 from '../../../packages/button'
import * as a14 from '../../../packages/button-deprecated'
import * as a15 from '../../../packages/card'
import * as a16 from '../../../packages/checkbox'
import * as a17 from '../../../packages/chip'
import * as a18 from '../../../packages/collapsable'
import * as a19 from '../../../packages/columns'
import * as a20 from '../../../packages/combobox'
import * as a21 from '../../../packages/config-menu'
import * as a22 from '../../../packages/container'
import * as a23 from '../../../packages/core'
import * as a24 from '../../../packages/currency-input'
import * as a25 from '../../../packages/data-group'
import * as a26 from '../../../packages/data-table'
import * as a27 from '../../../packages/date-input'
import * as a28 from '../../../packages/date-picker'
import * as a29 from '../../../packages/divider'
import * as a30 from '../../../packages/drawer'
import * as a31 from '../../../packages/dropdown'
import * as a32 from '../../../packages/dropdown-v2'
import * as a33 from '../../../packages/duration-input'
import * as a34 from '../../../packages/elevate'
import * as a35 from '../../../packages/field'
import * as a36 from '../../../packages/field-stack'
import * as a37 from '../../../packages/fieldset'
import * as a38 from '../../../packages/file-upload'
import * as a39 from '../../../packages/flex'
import * as a40 from '../../../packages/forms'
import * as a41 from '../../../packages/grid'
import * as a42 from '../../../packages/heading'
import * as a43 from '../../../packages/icon'
import * as a44 from '../../../packages/illustration'
import * as a45 from '../../../packages/inline'
import * as a46 from '../../../packages/keyboard-shortcuts'
import * as a47 from '../../../packages/link'
import * as a48 from '../../../packages/list'
import * as a49 from '../../../packages/loading'
import * as a50 from '../../../packages/media-query'
import * as a51 from '../../../packages/modal-dialog'
import * as a52 from '../../../packages/next-link'
import * as a53 from '../../../packages/notice'
import * as a54 from '../../../packages/pagination'
import * as a55 from '../../../packages/popover'
import * as a56 from '../../../packages/portal'
import * as a57 from '../../../packages/product-menu'
import * as a58 from '../../../packages/radio'
import * as a59 from '../../../packages/radio-button-group'
import * as a60 from '../../../packages/scroll-mask'
import * as a61 from '../../../packages/search-input'
import * as a62 from '../../../packages/segmented-control'
import * as a63 from '../../../packages/select-input'
import * as a64 from '../../../packages/select-menu'
import * as a65 from '../../../packages/side-drawer'
import * as a66 from '../../../packages/sidebar-navigation'
import * as a67 from '../../../packages/split-button'
import * as a68 from '../../../packages/stack'
import * as a69 from '../../../packages/strong'
import * as a70 from '../../../packages/table'
import * as a71 from '../../../packages/tabs'
import * as a72 from '../../../packages/tag'
import * as a73 from '../../../packages/text'
import * as a74 from '../../../packages/text-input'
import * as a75 from '../../../packages/text-link'
import * as a76 from '../../../packages/text-list'
import * as a77 from '../../../packages/textarea'
import * as a78 from '../../../packages/theme'
import * as a79 from '../../../packages/tile'
import * as a80 from '../../../packages/toast'
import * as a81 from '../../../packages/toggle'
import * as a82 from '../../../packages/tooltip'
import * as a83 from '../../../packages/tray'
import * as a84 from '../../../packages/tree-view'
import * as a85 from '../../../packages/utils'
import * as a86 from '../../../packages/virtualized-data-table'
import * as a87 from '../../../packages/wizard'

/** Monorepo packages **/
import * as a88 from '../../../../packages/ui/app-header'
import * as a89 from '../../../../packages/ui/application-logos'
import * as a90 from '../../../../packages/ui/error-boundary'
import * as a91 from '../../../../packages/ui/events'
import * as a92 from '../../../../packages/ui/formschema-enums'
import * as a93 from '../../../../packages/ui/hash-params'
import * as a94 from '../../../../packages/ui/load-style'
import * as a95 from '../../../../packages/ui/loader'
import * as a96 from '../../../../packages/ui/paginated-scrolling-list'
import * as a97 from '../../../../packages/ui/pendo'
import * as a98 from '../../../../packages/ui/react-beautiful-dnd'
import * as a99 from '../../../../packages/ui/reckon-balance-core'
import * as a100 from '../../../../packages/ui/reckon-balance-theme'
import * as a101 from '../../../../packages/ui/sidebar'
import * as a102 from '../../../../packages/ui/site-layout'
import * as a103 from '../../../../packages/ui/task-queue'
import * as a104 from '../../../../packages/ui/use-isomorphic-layout-effect'
import * as a105 from '../../../../packages/ui/use-next-before-unload'
import * as a106 from '../../../../packages/ui/use-openstate'
import * as a107 from '../../../../packages/ui/use-session-acknowledgements'
import * as a108 from '../../../../packages/ui/use-window-size'
import * as a109 from '../../../../packages/ui/wizard-hooks'

/** Additional packages **/
import * as a110 from 'lodash'
import * as a111 from '@faker-js/faker'
import * as a112 from 'use-resize-observer'
import * as a113 from 'react-hook-form'

export const mods = {

/** Design system packages **/  
'@balance-web/a11y': a0,
'@balance-web/accordion': a1,
'@balance-web/app-layout': a2,
'@balance-web/array-field': a3,
'@balance-web/aspect-ratio': a4,
'@balance-web/autocomplete': a5,
'@balance-web/avatar': a6,
'@balance-web/badge': a7,
'@balance-web/banner': a8,
'@balance-web/blanket': a9,
'@balance-web/bottom-drawer': a10,
'@balance-web/box': a11,
'@balance-web/breadcrumbs': a12,
'@balance-web/button': a13,
'@balance-web/button-deprecated': a14,
'@balance-web/card': a15,
'@balance-web/checkbox': a16,
'@balance-web/chip': a17,
'@balance-web/collapsable': a18,
'@balance-web/columns': a19,
'@balance-web/combobox': a20,
'@balance-web/config-menu': a21,
'@balance-web/container': a22,
'@balance-web/core': a23,
'@balance-web/currency-input': a24,
'@balance-web/data-group': a25,
'@balance-web/data-table': a26,
'@balance-web/date-input': a27,
'@balance-web/date-picker': a28,
'@balance-web/divider': a29,
'@balance-web/drawer': a30,
'@balance-web/dropdown': a31,
'@balance-web/dropdown-v2': a32,
'@balance-web/duration-input': a33,
'@balance-web/elevate': a34,
'@balance-web/field': a35,
'@balance-web/field-stack': a36,
'@balance-web/fieldset': a37,
'@balance-web/file-upload': a38,
'@balance-web/flex': a39,
'@balance-web/forms': a40,
'@balance-web/grid': a41,
'@balance-web/heading': a42,
'@balance-web/icon': a43,
'@balance-web/illustration': a44,
'@balance-web/inline': a45,
'@balance-web/keyboard-shortcuts': a46,
'@balance-web/link': a47,
'@balance-web/list': a48,
'@balance-web/loading': a49,
'@balance-web/media-query': a50,
'@balance-web/modal-dialog': a51,
'@balance-web/next-link': a52,
'@balance-web/notice': a53,
'@balance-web/pagination': a54,
'@balance-web/popover': a55,
'@balance-web/portal': a56,
'@balance-web/product-menu': a57,
'@balance-web/radio': a58,
'@balance-web/radio-button-group': a59,
'@balance-web/scroll-mask': a60,
'@balance-web/search-input': a61,
'@balance-web/segmented-control': a62,
'@balance-web/select-input': a63,
'@balance-web/select-menu': a64,
'@balance-web/side-drawer': a65,
'@balance-web/sidebar-navigation': a66,
'@balance-web/split-button': a67,
'@balance-web/stack': a68,
'@balance-web/strong': a69,
'@balance-web/table': a70,
'@balance-web/tabs': a71,
'@balance-web/tag': a72,
'@balance-web/text': a73,
'@balance-web/text-input': a74,
'@balance-web/text-link': a75,
'@balance-web/text-list': a76,
'@balance-web/textarea': a77,
'@balance-web/theme': a78,
'@balance-web/tile': a79,
'@balance-web/toast': a80,
'@balance-web/toggle': a81,
'@balance-web/tooltip': a82,
'@balance-web/tray': a83,
'@balance-web/tree-view': a84,
'@balance-web/utils': a85,
'@balance-web/virtualized-data-table': a86,
'@balance-web/wizard': a87,

/** Monorepo packages **/
'@reckon-web/app-header': a88,
'@reckon-web/application-logos': a89,
'@reckon-web/error-boundary': a90,
'@reckon-web/events': a91,
'@reckon-web/formschema-enums': a92,
'@reckon-web/hash-params': a93,
'@reckon-web/load-style': a94,
'@reckon-web/loader': a95,
'@reckon-web/paginated-scrolling-list': a96,
'@reckon-web/pendo': a97,
'@reckon-web/react-beautiful-dnd': a98,
'@reckon-web/reckon-balance-core': a99,
'@reckon-web/reckon-balance-theme': a100,
'@reckon-web/sidebar': a101,
'@reckon-web/site-layout': a102,
'@reckon-web/task-queue': a103,
'@reckon-web/use-isomorphic-layout-effect': a104,
'@reckon-web/use-next-before-unload': a105,
'@reckon-web/use-openstate': a106,
'@reckon-web/use-session-acknowledgements': a107,
'@reckon-web/use-window-size': a108,
'@reckon-web/wizard-hooks': a109,

/** Additional packages **/
'lodash': a110,
'@faker-js/faker': a111,
'use-resize-observer': a112,
'react-hook-form': a113,
}
